"use client";

import React from "react";
import { Facebook, Instagram, Music2, Twitter, Youtube } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="grid grid-cols-2 md:grid-cols-4 gap-y-4 gap-x-8 w-full">
        {[...Array(8)].map((_, i) => <div key={i} data-index={i} className="h-5 w-24 bg-primary/10 animate-pulse rounded" />)}
      </div>;
  }
  return <ul className="grid grid-cols-2 md:grid-cols-4 gap-y-4 gap-x-8 w-full text-center md:text-left">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-accent hover:text-primary transition-colors text-sm font-logo">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function SiteFooter() {
  const currentYear = new Date().getFullYear();
  const socialLinks = [{
    name: "Instagram",
    icon: Instagram,
    href: "#"
  }, {
    name: "TikTok",
    icon: Music2,
    href: "#"
  }, {
    name: "X",
    icon: Twitter,
    href: "#"
  }, {
    name: "YouTube",
    icon: Youtube,
    href: "#"
  }, {
    name: "Facebook",
    icon: Facebook,
    href: "#"
  }];
  const legalLinks = [{
    label: "Terms of Use",
    href: "#"
  }, {
    label: "Privacy Policy",
    href: "#"
  }, {
    label: "ADA Accessibility",
    href: "#"
  }];
  return <footer id="site-footer" className="dark bg-background text-foreground py-16 px-4 md:px-8">
      <div className="max-w-7xl mx-auto flex flex-col gap-12">
        {}
        <div className="flex flex-col items-center text-center gap-6 text-accent font-logo">
          <img src="/img/night_platinum_nights_logo_footer.png" alt="Platinum Nights Logo" className="h-7 w-auto" />
          <div className="flex flex-col gap-1.5 text-sm">
            <p>(555) 987-6543</p>
            <p>7700WP Bill Atkinson Blvd., Oklahoma, Oklahoma City 73069</p>
            <p>info@nightplatinum.com</p>
          </div>
        </div>

        <Separator className="bg-primary/15" />

        {}
        <div className="flex justify-center w-full px-4 md:px-12">
          <MenuProvider menu_id="45" className="w-full">
            <FooterMenuConsumer />
          </MenuProvider>
        </div>

        <Separator className="bg-primary/15" />

        {}
        <div className="flex flex-col lg:flex-row justify-between items-center gap-8 text-sm text-accent font-logo">
          <div className="text-center lg:text-left order-3 lg:order-1">
            &copy; {currentYear} Platinum Nights. All rights reserved.
          </div>

          <ul className="flex flex-wrap justify-center gap-6 order-2 lg:order-2">
            {legalLinks.map((link, i) => <li key={link.label} data-index={i}>
                <Link to={link.href} className="hover:text-primary transition-colors">
                  {link.label}
                </Link>
              </li>)}
          </ul>

          <div className="flex items-center gap-4 order-1 lg:order-3">
            {socialLinks.map((social, i) => {
            const Icon = social.icon;
            return <Link key={social.name} to={social.href} data-index={i} className="flex items-center justify-center w-10 h-10 rounded-full border border-primary text-primary hover:bg-primary hover:text-background transition-colors shrink-0" aria-label={social.name}>
                  <Icon className="w-4 h-4" />
                </Link>;
          })}
          </div>
        </div>
      </div>
    </footer>;
}